"use client";

// Frase rotativa del hero — "mitad de tiempo." / "mitad del costo." /
// "mitad del esfuerzo." cada 3.2s con crossfade (`setRotator()` en el
// handoff). El tweak `rotator` está ON por default.

import { useEffect, useState } from "react";

const PHRASES = ["mitad de tiempo.", "mitad del costo.", "mitad del esfuerzo."];
// El ghost reserva el ancho del wrapper — tiene que ser la frase más larga
// (no siempre PHRASES[0]) para que ninguna rotación se desborde sobre la
// imagen del hero.
const LONGEST_PHRASE = PHRASES.reduce((a, b) => (b.length > a.length ? b : a));

export function TitleRotator() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % PHRASES.length), 3200);
    return () => clearInterval(id);
  }, []);

  return (
    <span className="tl-rot-wrap">
      <span className="tl-rot-ghost" aria-hidden="true">{LONGEST_PHRASE}</span>
      {PHRASES.map((p, i) => (
        <span key={p} className={`tl-rot${i === idx ? "" : " tl-rot-out"}`}>{p}</span>
      ))}
    </span>
  );
}
